"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;

var _utils = require("../../../../utils");

/**
 * @private
*/
var colors = {
  default: '#000000',
  general: '#b3e6b1',
  marginal: '#6cbd69',
  slight: '#f4f964',
  enhanced: '#e0b767',
  moderate: '#e0686a',
  high: '#fe59ff'
};
/**
 * @private
*/

var config = {
  data: {
    request: {
      endpoint: 'convective/outlook',
      action: "search"
      /* SEARCH */
      ,
      parameters: {
        filter: 'geo'
      }
    },
    properties: {
      id: 'id',
      category: 'details.risk.type',
      timestamp: {
        from: 'details.range.minTimestamp',
        to: 'details.range.maxTimestamp'
      },
      path: 'geoPoly'
    }
  },
  style: {
    polygon: function (data) {
      var type = (0, _utils.get)(data, 'details.risk.type');
      return {
        fill: {
          color: colors[type] || colors.default,
          opacity: 1
        }
      };
    }
  }
};
exports.config = config;
var _default = config;
exports.default = _default;